import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";
const ListItemText = styled.span`
  border-bottom: 0.2px solid #bdbdbd;
  margin: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  padding: 5px 0;
`;
const ListItems = ({ text }) => {
  return <ListItemText dangerouslySetInnerHTML={{ __html: text }} />;
};

ListItems.propTypes = {
  text: PropTypes.node.isRequired,
};

export default ListItems;
